import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const SF3D = () => {
    return (
        <Box sx={{
            backgroundColor: '#f5f5f5',
            minHeight: 'calc(100vh - 64px)', // Adjust based on your Navbar height
            pt: { xs: '80px', md: '100px' }, // Responsive padding top
            pb: 8
        }}>
            <Container maxWidth="lg">
                <Paper elevation={3} sx={{ p: { xs: 2, sm: 4 }, borderRadius: 2 }}>
                    <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ fontWeight: 600, mb: 3 }}>
                        SF3D
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                        {/* Embed Agent with iframe */}
                        <iframe
                            src="https://stabilityai-stable-fast-3d.hf.space"
                            frameBorder="0"
                            style={{
                                border: '1px solid #e0e0e0',
                                borderRadius: '8px',
                                width: '100%',
                                maxWidth: '850px',
                                height: '600px',
                                display: 'block'
                            }}
                            title="SF3D"
                        ></iframe>
                        <Typography variant="caption" sx={{ mt: 2, color: 'text.secondary' }}>
                            Agent interactif hébergé sur Hugging Face Spaces.
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default SF3D; 